import { Badge, Text, Tooltip } from '@/design-system/components/ui';

interface Props {
  label: string;
  value: string;
  tooltip: string;
}

export const TriggerValueDetailWithTooltip = ({ label, value, tooltip }: Props) => {
  return (
    <div className="tw:flex tw:flex-col">
      <Text variant="body-sm" weight="bold" className="tw:mb-1">
        {label}
      </Text>
      <Tooltip content={tooltip}>
        <Badge size="sm">{value || 'N/A'}</Badge>
      </Tooltip>
    </div>
  );
};
